// extracted by mini-css-extract-plugin
export default {"container":"PasswordChangeSuccessModal_container__QEnIa","icon":"PasswordChangeSuccessModal_icon__Gi+9O","title":"PasswordChangeSuccessModal_title__7hBjU"};